import { render, staticRenderFns } from "./OrdersVsSupplies.vue?vue&type=template&id=969ed206&scoped=true&"
import script from "./OrdersVsSupplies.vue?vue&type=script&lang=js&"
export * from "./OrdersVsSupplies.vue?vue&type=script&lang=js&"
import style0 from "./OrdersVsSupplies.vue?vue&type=style&index=0&id=969ed206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969ed206",
  null
  
)

export default component.exports